import PropTypes from "prop-types";
import Iconify from "../../../layouts/components/iconify/iconify";

const ViewToggle = ({ viewType, onListViewClick, onCardViewClick }) => {
  return (
    <div className="shorting-tabs">
      <div
        className={`view-items grid-list ${viewType === "list" ? "active" : ""}`}
        title="List View"
        onClick={onListViewClick}
      >
        <Iconify icon="line-md:list-3-filled" />
      </div>
      <div
        className={`view-items card-list ${viewType === "card" ? "active" : ""}`}
        title="Card View"
        onClick={onCardViewClick}
      >
        <Iconify icon="mdi:view-grid" />
      </div>
    </div>
  );
};

ViewToggle.propTypes = {
  viewType: PropTypes.oneOf(["list", "card"]).isRequired,
  onListViewClick: PropTypes.func.isRequired,
  onCardViewClick: PropTypes.func.isRequired,
};

export default ViewToggle;
